<template>
  <div class="">
    <div class="lg:grid lg:grid-cols-12 lg:grid-rows-2">
      <div
        class="relative bg-gray-900 z-10 lg:z-0 lg:col-span-12 lg:col-start-1 lg:row-start-1 lg:row-span-2 lg:rounded-2xl"
      >
        <div
          class="relative lg:rounded-2xl lg:overflow-hidden lg:grid lg:grid-rows-2"
        >
          <div
            v-if="image"
            class="absolute inset-0 lg:row-start-1 lg:row-span-2"
          >
            <TLazyimg
              :src="image"
              classes="h-full w-full"
              classes-img="block w-full h-full object-cover"
              alt=""
            />

            <div
              class="absolute inset-0 bg-primary-900/40 mix-blend-multiply"
            />
          </div>

          <div
            class="relative px-6 py-16 lg:px-8 lg:pt-32 lg:pb-0 text-center lg:row-start-1 lg:row-span-1"
          >
            <TTitle tag="h1" size="5xl" :bold="true" classes="mb-0">
              <span class="block text-white">{{ title }}</span>
              <span class="block text-primary-300">{{ name }}</span>
            </TTitle>
          </div>
        </div>
      </div>
      <div
        class="relative z-10 lg:col-span-10 lg:col-start-2 lg:row-start-2 lg:flex lg:flex-col lg:justify-start lg:pt-8"
      >
        <div class="bg-gray-100 p-4 lg:p-1 rounded-lg relative">
          <div class="">
            <TSearch :location="location"></TSearch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface propsInterface {
  image: string
  title: string
  name?: string
  location?: string
}

defineProps<propsInterface>()
</script>
